import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Input from '../../components/abstractObjects/Input';
import { selectVarById, updateAuthorizedSupervisor } from '../var/varSlice'
import { selectAllSupervisors } from '../supervisors/supervisorsSlice'
import { Label } from '../../components/abstractObjects/Label'
import * as Constants from '../constants'

export const AuthorizedSupervisorForm = ({ varId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))
    const { user } = useSelector(state => state ? state.user : null)

    const [SupervisorId, setSupervisorId] = useState({ value: varx.SupervisorId, error: null })
    const [ReasonForReferBack, setReasonForReferBack] = useState({ value: varx.ReasonForReferBack !== null ? varx.ReasonForReferBack : "", error: null })

    const onSupervisorIdChanged = (e) => setSupervisorId({ value: e.target.value, error: null })
    const onReasonForReferBackChanged = (e) => {
        setReasonForReferBack({ value: e.target.value, error: null })
        updateObj({ ReasonForReferBackValue: e.target.value })
    }

    var supervisors = useSelector(selectAllSupervisors)
    supervisors = supervisors.filter(x => x.ConsigneeIds.includes(varx.ConsigneeId))
    var supervisor = supervisors.find(x => x.Id === SupervisorId.value && x.Id != user.ConsigneeId)

    const dispatch = useDispatch()

    const updateObj = ({ action, ReasonForReferBackValue }) => {
        if (!SupervisorId.value) {
            setSupervisorId({ error: "Required!" })
            return false
        }
        if (action === "UNAPPROVE" && !ReasonForReferBack.value) {
            setReasonForReferBack({ error: "Required!" })
            return false
        }
        //console.log("test ref com", action, ReasonForReferBack, ReasonForReferBackValue, SupervisorId)
        dispatch(
            updateAuthorizedSupervisor({
                VarTransactionId: varId,
                SupervisorId: SupervisorId.value,
                ReasonForReferBack: ReasonForReferBackValue ?? ReasonForReferBack.value
            })
        )
        return true
    }

    const authorizedSupervisorForm = (
        <div>
            {!varx.ImSupervisor ?
                (<div style={{ padding: 16 }}>
                    <Label text="NAME_*" /><Input type="select" value={SupervisorId.value ? SupervisorId.value : ""} error={SupervisorId.error} selectOptions={supervisors} onChange={onSupervisorIdChanged} readonly={varx.ImSupervisor} />
                    <Label text="EMAIL" /><Input value={supervisor ? supervisor.Email : ""} readonly />
                </div>)
                :
                (<div style={{ padding: 16 }}>
                    <Label text="REFER_BACK_COMMENT" />
                    <Input variant="outlined"
                        multiline minRows="4"
                        error={ReasonForReferBack.error}
                        value={ReasonForReferBack.value}
                        readonly={varx.StatusId !== Constants.VAR_STATUS_REFERBACKSD && varx.StatusId !== Constants.VAR_STATUS_SUBMITTED}
                        onChange={onReasonForReferBackChanged}
                        style={{ height: 120 }} />
                </div>)}
        </div>
    )
    return [authorizedSupervisorForm, updateObj];
}
//{ReasonForReferBack.error ? <p className="errorMessage">{}</p> : null}                    
export default AuthorizedSupervisorForm;